import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import ErrorPage from "../../ErrorPage/ErrorPage";
import { useProximidad } from "../../../hooks/useProximidad";
import { YsocialContext } from "../../../contexts/YsocialContext";
import PageWrapper from "../../../components/PageWrapper/PageWrapper";
import { Button, Modal, Separador } from "app-principal-componentes-visuales";
import LocalidadError from "../../../components/Modals/LocalidadError/LocalidadError";
import ProximidadUbicacion from "../../../components/Modals/ProximidadUbicacion/ProximidadUbicacion";
import DatosYsocialComponent from "../../../components/WebYsocial/DatosYsocialComponent/DatosYsocialComponent";
import DireccionSeleccionadaComponent from "../../../components/WebYsocial/DireccionSeleccionadaComponent/DireccionSeleccionadaComponent";
import { DATOS_CONTACTOS_YSOCIAL, DATOS_CONTACTOS_YSOCIAL_STATE, FORMULARIO_BARRIO_CERRADO_YSOCIAL, FORMULARIO_CONTACTO_YSOCIAL, FORMULARIO_DOMICILIO_YSOCIAL, redirectTo, RESUMEN_YSOCIAL, SELECCIONAR_DIRECCION_YSOCIAL } from "../../../utils/constants";
import ReintentarYsocialComponent from "../../../components/WebYsocial/ReintentarYsocialComponent/ReintentarYsocialComponent";
import SintomasSkeleton from "../../../components/Skeletons/SintomasSkeleton/SintomasSkeleton";
import { obtenerProvinciasYsocial } from "../../../helpers/WebYsocial/direccionesHelper";
import TipoFormulario from "../../../components/Modals/TipoFormulario/TipoFormulario";
import { useDirecciones } from "../../../hooks/useDirecciones";
import { inicioLocationWeb } from "../../../helpers/geolocalizacion";
import "./DatosContactosYsocial.scss";

const DatosContactosYsocial = () => {

  const history = useHistory();
  const { ysocial, setHomeYsocial, useRequest, dispatchYsocial } = useContext(YsocialContext);
  const socio = ysocial.socioSeleccionado;
  const { apiRequest } = useRequest();
  const { usuario, provincias } = ysocial;
  const [selectedDirection, setSelectedDirection] = useState(null);
  const [reintentarError, setReintentarError] = useState(false);
  const [provinciaSkeleton, setProvinciaSkeleton] = useState(false);
  const [showTipoFormularioModal, setShowTipoFormularioModal] = useState(false);
  
  const { error,
    localidadError,
    proximidadModal,
    direccionProxima,
    onClickContinuar,
    handleClickCambiarDireccionProximidad,
    handleClickValidarProximidad,
    setError,
    setLocalidadError,
    setProximidadModal } = useProximidad();

    const { foundSelected } = useDirecciones({ 
      socioPrincipal: usuario, 
      apiRequest, 
      direccionesSocio: usuario.direcciones, 
      isYsocial: true 
    });

  useEffect(() => {
    if((!provincias || provincias.length === 0) && reintentarError === false) {
      setReintentarError(false)
      setProvinciaSkeleton(true);
      obtenerProvinciasYsocial(apiRequest, dispatchYsocial, setReintentarError, setProvinciaSkeleton)
    }
  }, [provincias])
  
  useEffect(() => {
    setHomeYsocial(true);
    inicioLocationWeb(dispatchYsocial);
    setSelectedDirection(foundSelected(usuario.direcciones));
  }, [ysocial]);

  const handleEditarContacto = () => {
    history.push(FORMULARIO_CONTACTO_YSOCIAL, { socio })
  };

  const handleEditarUbicacion = () => {
    const isBarrioCerrado = selectedDirection?.barrioCerrado;
    history.push(
      isBarrioCerrado ?  
      FORMULARIO_BARRIO_CERRADO_YSOCIAL : 
      FORMULARIO_DOMICILIO_YSOCIAL, {
        selectedDirection,
        showEliminar: true,
        fromState: DATOS_CONTACTOS_YSOCIAL_STATE
    })
  }

  const handleCambiarUbicacion = () => {
    history.push(SELECCIONAR_DIRECCION_YSOCIAL);
  }

  const handleAgregarDatosContacto = () => {
    history.push(FORMULARIO_CONTACTO_YSOCIAL, { socio })
  }

  const handleAgregarNuevoDomicilio = () => {
    setShowTipoFormularioModal(true);
  }

  const handleReintentar = () => {
    setReintentarError(false);
    obtenerProvinciasYsocial(apiRequest, dispatchYsocial, setReintentarError, setProvinciaSkeleton);
  }

  if (error) {
    return <ErrorPage setError={setError} />
  }

  if(provinciaSkeleton) {
		return (
			<PageWrapper 
        notBack={true}
				socio={ysocial.usuario} 
				pageClassName="asistencia-seleccionar-domicilio"
				path={DATOS_CONTACTOS_YSOCIAL}
				className="verificar-datos-grid"
			>
				<SintomasSkeleton />
			</PageWrapper>
    )
	}


  if(reintentarError) {
    return (
			<PageWrapper 
				socio={ysocial.usuario} 
				pageClassName="asistencia-seleccionar-domicilio"
				path={DATOS_CONTACTOS_YSOCIAL} className="reintentar-ysocial" 
        notCancel={false}
        notBack={true}
			>
				<ReintentarYsocialComponent onClick={() => {handleReintentar()}} />
        <Button
          id="contacto-ysocial-continuar"
          primary
          label="Continuar"
          className="continuar__ysocial__button"
          disable={true}
        />
			</PageWrapper>
		)
  }

  return (
    <>
      <PageWrapper
        socio={socio}
        pageClassName="datos-ysocial"
        path={DATOS_CONTACTOS_YSOCIAL}
        notCancel={false}
        notBack={true}
      >

        <DatosYsocialComponent socio={socio} handleEditarContacto={handleEditarContacto} handleAgregarDatosContacto={handleAgregarDatosContacto} />

        <Separador />

        <DireccionSeleccionadaComponent 
          selectedDirection={selectedDirection} 
          handleCambiarUbicacion={handleCambiarUbicacion} 
          handleAgregarNuevoDomicilio={handleAgregarNuevoDomicilio} 
          socio={socio}
        />

        <Button
          id="contacto-ysocial-continuar"
          primary
          label="Continuar"
          className="continuar__ysocial__button"
          onClick={() => handleClickValidarProximidad(selectedDirection)}
          disable={!socio.email || !socio.telefono ? true : false || !selectedDirection }
        />
      </PageWrapper>

      <Modal
        screen60
        className="modal_web"
        component={
          <ProximidadUbicacion
            onClickContinuar={() => onClickContinuar(selectedDirection)}
            onClickCambiarDireccion={handleClickCambiarDireccionProximidad}
            direccionMasProxima={direccionProxima}
          />
        }
        setShowModal={setProximidadModal}
        showModal={proximidadModal}
        id="modal-proximidad-ubicacion"
      />

      <Modal
        screen60
        hideCloseBtn
        //@ts-ignore
        component={
          <LocalidadError
            setLocalidadError={setLocalidadError}
          />
        }
        setShowModal={setLocalidadError}
        showModal={localidadError}
        id="modal-localidad-error"
      />

      <Modal
        className='modal_web'
        //@ts-ignore
        component={
            <TipoFormulario 
                pathDomicilio={FORMULARIO_DOMICILIO_YSOCIAL}
                pathBarrioCerrado={FORMULARIO_BARRIO_CERRADO_YSOCIAL}
                propsDomicilio={{fromState: DATOS_CONTACTOS_YSOCIAL, redirectTo: RESUMEN_YSOCIAL}}
                propsBarrioCerrado={{fromState: DATOS_CONTACTOS_YSOCIAL, redirectTo: RESUMEN_YSOCIAL}}
            />
        }
        setShowModal={setShowTipoFormularioModal}
        showModal={showTipoFormularioModal}
        id="tipo-formulario-modal" 
      />
    </>
  );
};

export default DatosContactosYsocial;
